import { useMemo } from "react";
import { Controller } from "react-hook-form";

import { GoogleFreeBookingLinksHotelType } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormHotelType = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();
	const {
		control,
		formState: { errors },
	} = form;

	const options = useMemo<Array<FormOptionType>>(
		() => [
			{
				id: GoogleFreeBookingLinksHotelType.Hotel,
				label: "ホテル・旅館",
				value: GoogleFreeBookingLinksHotelType.Hotel,
			},
			{
				id: GoogleFreeBookingLinksHotelType.VacationRental,
				label: "民泊",
				value: GoogleFreeBookingLinksHotelType.VacationRental,
			},
			{
				id: GoogleFreeBookingLinksHotelType.OutdoorLodging,
				label: "屋外宿泊施設",
				value: GoogleFreeBookingLinksHotelType.OutdoorLodging,
			},
		],
		[],
	);
	return (
		<QuestionForMain
			title={"施設のカテゴリ"}
			required
			inputChildren={
				<Controller
					name="hotelType"
					control={control}
					render={({ field }) => (
						<SelectField
							className="w-fit"
							value={field.value}
							options={options}
							errorMessage={errors?.hotelType?.message}
							handleValueChange={field.onChange}
						/>
					)}
				/>
			}
		/>
	);
};
